import React from 'react';

const QuizQuestion = props => {
	const { question } = props;
	return (
		<div className="question-section__question">
			<h3>{question}</h3>
		</div>
	);
};

export default QuizQuestion;



// WEBPACK FOOTER //
// ./src/components/quiz/QuizQuestion.js